<div #overlay class="overlay">
    <div class="content center-content">
        <div class="column-flex">
            <mat-icon
                svgIcon="profile-cross"
                class="icon"
                data-cy="vessel-folder-req-access-leave-proj-conf-modal-icon" />
            <div class="title" data-cy="vessel-folder-req-access-leave-proj-conf-modal-header">
                {{ 'version.leave.dialog.form.title' | translate }}
            </div>
            <div class="subtitle" data-cy="vessel-folder-req-access-leave-proj-conf-modal-body">
                {{ 'version.leave.dialog.form.subtitle' | translate }}
            </div>

            <div class="buttons-container">
                <div
                    class="cancel button"
                    data-cy="vessel-folder-req-access-leave-proj-conf-modal-cancel-btn"
                    (click)="cancel()">
                    {{ 'version.leave.dialog.form.button.cancel' | translate }}
                </div>
                <div
                    class="button"
                    data-cy="vessel-folder-req-access-leave-proj-conf-modal-confirm-btn"
                    (click)="leaveVersion()">
                    {{ 'version.leave.dialog.form.button.confirm' | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
